import { Box, styled } from "@mui/material";
import SEO from "components/SEO";
import NewHero from "components/NewHero";
import QuizSection from "components/QuizSection";
import { Benefits, Personalization, SocialProof, FAQ, FinalCTA, StickyMobileCTA } from "components/LandingSections";

// Fixed background image container
const FixedBackground = styled(Box)({
  position: "fixed",
  inset: 0,
  zIndex: 0,
  "& .bg-image": {
    position: "absolute",
    inset: 0,
    backgroundImage: 'url(/e7e240850fa17209200eea382be1c90ed7eca601.png)',
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    height: "100%",
    filter: "grayscale(100%) contrast(1.25) brightness(1.1)",
  },
  "& .bg-overlay": {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(to bottom, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.85) 100%)",
  }
});

const PageContainer = styled(Box)({
  minHeight: "100vh",
  background: "#000000",
  position: "relative",
});

const ContentWrapper = styled(Box)({
  position: "relative",
  zIndex: 10,
});

function HomePage() {
  const scrollToQuiz = () => {
    document.getElementById("quiz-section")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <SEO
        title="Build Your Dream Physique - AI-Powered Calisthenics Training"
        description="Science-backed calisthenics programs tailored to your body, goals, and schedule. Get visible results in 30 days with AI-powered workout plans."
        keywords="AI calisthenics, bodyweight workout, fitness transformation, workout plan, build muscle, calisthenics training"
      />

      <PageContainer>
        {/* Fixed Background */}
        <FixedBackground>
          <Box className="bg-image" />
          <Box className="bg-overlay" />
        </FixedBackground>

        {/* Content */}
        <ContentWrapper>
          <NewHero onCTAClick={scrollToQuiz} />
          <QuizSection />
          <Benefits />
          <Personalization onCTAClick={scrollToQuiz} />
          <SocialProof />
          <FAQ />
          <FinalCTA onCTAClick={scrollToQuiz} />
          <StickyMobileCTA onCTAClick={scrollToQuiz} />
        </ContentWrapper>
      </PageContainer>
    </>
  );
}

export default HomePage;
